export default __webpack_public_path__ + "static/media/tarta.16021601.jpg";